export const initialChats = {
  mark: [
    {
      id: "mark-1",
      sender: "Mark",
      content: "Hey, Jessica. I reviewed the new dashboard idea and it looks promising.",
      createdAt: "9:12 AM"
    },
    {
      id: "mark-2",
      sender: "Me",
      content: "Nice. I want the layout to feel more modern and portfolio-ready.",
      createdAt: "9:14 AM"
    },
    {
      id: "mark-3",
      sender: "Mark",
      content: "Then we should improve hierarchy, spacing and make the UI feel more premium.",
      createdAt: "9:16 AM"
    }
  ],
  lester: [
    {
      id: "lester-1",
      sender: "Lester",
      content: "I can help split the layout into reusable components.",
      createdAt: "10:05 AM"
    },
    {
      id: "lester-2",
      sender: "Me",
      content: "Perfect. I want cleaner structure and better responsiveness too.",
      createdAt: "10:07 AM"
    }
  ],
  rebeca: [
    {
      id: "rebeca-1",
      sender: "Rebeca",
      content: "The contrast and spacing are already better now.",
      createdAt: "11:20 AM"
    },
    {
      id: "rebeca-2",
      sender: "Me",
      content: "Yes, but I still want it to look stronger for my portfolio.",
      createdAt: "11:22 AM"
    }
  ],
  astrodev: [
    {
      id: "astrodev-1",
      sender: "Astrodev",
      content: "A project stands out more when it looks like a product, not just an exercise.",
      createdAt: "1:30 PM"
    }
  ]
}